import styles from "./invitation-mail.module.css";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { X } from "lucide-react";

const InvitationMail = ({
  email,
  role,
  onRoleChange,
  onEmailRemoval,
  index,
}) => {
  const { t } = useTranslation();

  const roles = [
    {
      name: t("onboarding.admin.first-step.invitation-mail.role.player"),
      code: "player",
    },
    {
      name: t("onboarding.admin.first-step.invitation-mail.role.captain"),
      code: "captain",
    },
  ];

  const getInitials = () => {
    return email.slice(0, 2).toUpperCase(); // Extracts the first two characters
  };

  return (
    <div className={styles.wrapper}>
      <div
        className={`${styles.circle} ${styles[`circle-${(index % 4) + 1}`]}`}
      >
        <p className="title-4">{getInitials()}</p>
      </div>
      <div className={styles["email-content"]}>
        <div className={styles.email}>
          <p className={`title-3-variant-low ${styles["email-label"]}`}>
            {email}
          </p>
          <X
            size={16}
            className={`icon icon-navigation ${styles.close}`}
            onClick={(e) => onEmailRemoval(email, e.target.value)}
          />
        </div>
        <Dropdown
          value={role}
          onChange={(e) => onRoleChange(email, e.value)}
          options={roles}
          optionLabel="name"
          placeholder={t(
            "onboarding.admin.first-step.invitation-mail.role.placeholder"
          )}
          className={styles.dropdown}
        />
      </div>
    </div>
  );
};

export default InvitationMail;
